var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","overflow":"auto","text-align":"center"}},[_c('img',{staticStyle:{"width":"100%","max-width":"1260px"},attrs:{"src":"https://bn-visas-front.oss-cn-hangzhou.aliyuncs.com/images/wangdan-introduction.png","alt":_vm.$t('platform.wangdanIntroAlt')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }